// The numbered section titles of each guide, in order. The Guide page uses them for search and
// "scroll to section"; guideModules.test.jsx checks each one is a real heading in its guide.

export const gettingStartedSections = [
  'Signing In and Your Role',
  'Roles at a Glance',
  'Who Sees Which Page',
  'The Sidebar',
  'Notifications',
  'What’s New, Learning and Support',
]

export const approvalsSections = [
  'What the Approvals Page Shows',
  'Reviewing a Request',
  'Assigning an Approver',
  'Who Can Approve',
]

export const outlookSections = [
  'What the Add-in Does',
  'Sending Documents from Outlook',
  'Requirements and Sign-in',
  'For Admins: Branding and Routing',
]

export const learningSections = ['Watching a Video', 'Managing Learning Content']

export const outputSections = [
  'What Output Destinations Are',
  'Adding an FTP / SFTP Destination',
  'Adding an Azure SQL Destination',
  'Linking a Destination to a Template',
  'Delivery History and Re-export',
]

export const integrationsSections = [
  'Posting to Business Central or NetSuite',
  'Setting Up a Template',
  'Reviewing and Posting a Request',
  'When a Post Fails',
  'Connections per OpCo',
]

export const billingSections = [
  'What Billing & Analytics Shows',
  'The Seven Tabs',
  'Pages, Tokens and Cost',
  'Templates and People: Drill-downs',
  'Your Plan and Billing Month',
  'Billing per OpCo',
]

export const recycleSections = ['What Lands in the Recycle Bin', 'Restoring an Item']

export const opcoWorkingSections = [
  'What an OpCo Is',
  'Switching Workspace',
  'What You See Inside an OpCo',
  'Admins and Members',
  'Moving a Request to Another OpCo',
  'If You See “No OpCo Access”',
]

export const opcoSections = [
  'What a Super Admin Is',
  'Setting Up OpCos',
  'Admins and Members',
  'Bringing Someone’s Existing Work Into an OpCo',
  'Auto-assign: Membership by Email',
  'Domains and Mailboxes',
  'Super Admins Panel',
  'Unassigned Templates and Requests',
  'NetSuite and Business Central per OpCo',
  'Billing Split and Org-wide Settings',
]

export const usersSections = [
  'Overview Stats',
  'Users Table',
  'User Actions',
  'Changing User Roles',
  'Deactivating Users',
  'Roles and Permissions',
  'Inviting People and Groups',
  'If You Are Not an Admin',
]
